import {gql} from '@apollo/client';

export default gql`
  mutation splitAd($input: SplitAdInput!) {
    splitAd(input: $input) {
      success
    }
  }
`;
